
import TimeCountdown from '@/components/TimeCountdown'
export default {
    name: 'realNameStatus',
    components: {
        TimeCountdown
    },
    data() {
        return {
            timers: '',
            submitting: true,
            certifyRes: {
                failReason: null,
                passed: null
            },
            ok: false,
            error: false
        }
    },
    methods: {
        countDownEnd() {
            this.UserCertifyForH5()
        },
        UserCertifyForH5() {
            let p = {
                action: {
                    certifyId: this.$route.query.certifyId
                }
            }
            this.$api.queryUserCertify(p).then((res) => {
                this.submitting = false
                if (!res.success) {
                    this.error = true
                    return
                }
                if (res.data.passed) {
                    this.ok = true
                }
                if (!res.data.passed) {
                    this.error = true
                }
                this.certifyRes = res.data
            })
        }
    }
}
